import { useCallback, useState } from 'react';

export const useForceRerender = () => {
  const [, setState] = useState(0);

  return useCallback(() => setState((prevState) => prevState + 1), []);
};
